export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `44`, `46`, `48`, `50`, `52`],
  [`Рост`, `170`, `170`, `170`, `170`, `170`],
  [`Объем груди(a)`, `88`, `92`, `96`, `100`, `104`],
  [`Обхват бёдер (b)`, `94`, `98`, `102`, `106`, `110`],
  [`Ширина изделия по груди (c)`, `40`, `42`, `43`, `45`, `48`],
  [`Длина изделия (d)`, `63`, `64`, `65`, `68`, `69`]
];
